import DOMPurify from 'dompurify'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import { QuickMenu } from '../../@types/aboutfishing'
import { RNPostMessage, AFWebLinkType, sendSetAppsflyerEvent } from '../../js/postMessage'
import { onErrorImg } from '../../js/script'
import { useAppContext } from '../provider/AppProvider'

type PropsTypes = {
  el: any
  menu: QuickMenu[]
  index: number
}

export default function HomeQuick({ el, menu, index }: PropsTypes) {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  const appNavigationHandler = (el: QuickMenu) => {
    const buildAppUrl = (target: string) => `aboutfishing://aboutfishing.com/?page=webview&url=${target}`
    const targetUrl = el.type === 'url' ? el.landingTarget : `${process.env.REACT_APP_SHOP_URL}${el.path}`
    RNPostMessage(AFWebLinkType.moveToLink, { url: buildAppUrl(targetUrl) })
  }

  const webNavigationHandler = (el: QuickMenu) => {
    if (el.type === 'url') {
      window.location.href = el.landingTarget // 외부 URL은 그대로 처리
    } else {
      navigate(el.path) // 내부 경로는 navigate로 처리
    }
  }

  const handleClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, el: QuickMenu) => {
    e.preventDefault()
    if (isAppView) appNavigationHandler(el)
    else webNavigationHandler(el)
  }

  return (
    <div
      className='theme_category'
      style={{ minHeight: isMobile ? '181px' : '336px' }}
      onClick={(): void => {
        const gtmNavigateClick: DataLayerArgs = {
          dataLayer: {
            event: 'select_content',
            event_info: {
              content_type: '홈모듈',
              content_id: String(el.sectionNo),
              content_name: el.sectionName,
            },
          },
        }
        if (isAppView) {
          sendSetAppsflyerEvent({
            eventName: 'select_content',
            eventType: {
              content_type: '홈모듈',
              content_id: String(el.sectionNo),
              content_name: el.sectionName,
            },
          })
        } else {
          TagManager.dataLayer(gtmNavigateClick)
        }
      }}
    >
      <ul>
        {menu?.map((el: any, idx: number): JSX.Element => {
          return (
            <li key={idx}>
              <span onClick={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => handleClick(event, el)}>
                <div className='item_wrap'>
                  <div className='item_img'>
                    <img src={el.image} alt='' onError={onErrorImg} />
                  </div>
                  <div className='item_title' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(el?.title) }}></div>
                </div>
              </span>
            </li>
          )
        })}
      </ul>
      {index !== 0 && <hr />}
    </div>
  )
}
